export default __webpack_public_path__ + "static/media/fon-circle.4ce5710c.png";